export default __webpack_public_path__ + "3766e0fe54cea888519f4b490db348dc.png";